(() => {
    let videoComponents = document.querySelectorAll('.image-video__background.lightbox');
    if (videoComponents.length) {
        [...videoComponents].map((videoComponent)=>{
            let videoId = videoComponent.dataset.lightboxVideo;
            let isItVimeo = /^[0-9]+$/.test(videoId);
            // if background exist
            if(!videoComponent.getAttribute('style') || videoComponent.getAttribute('style') && !videoComponent.getAttribute('style').includes('background')) {
                if (isItVimeo) {
                    fetch(`https://vimeo.com/api/v2/video/${videoId}.json`)
                    .then(response => response.json())
                    .then(function(data) {
                        let vimeoThumbnail = data[0].thumbnail_large;
                        videoComponent.style.backgroundImage = `url(${vimeoThumbnail})`
                    })
                } else {
                    videoComponent.style.backgroundImage = `url(https://img.youtube.com/vi/${videoId}/hqdefault.jpg)`
                }
            }
        })
    }
})()
